import React from "react";
import { LEGAL_UPDATED_LABEL, LEGAL_VERSION } from "@/legal/version";

const CancellationRefund = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-2">Cancellation and Refund Policy</h1>
      <p className="text-sm text-charcoal mb-6">
        Version {LEGAL_VERSION} · Last updated {LEGAL_UPDATED_LABEL}
      </p>
      <p className="mb-4">
        This policy covers ByOnco subscription access sold on getbyonco.com (monthly, yearly, and
        lifetime plans) and one-time paid services such as a second-opinion consult. It does not
        describe hospital admissions, lab bookings, or travel packages sold by third parties.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">How billing works</h2>
      <p className="mb-4">
        Plans are prepaid one-time Razorpay orders for a stated period (or lifetime). We do not
        automatically charge your card again at the end of a period. When a monthly or yearly period
        ends, access stops unless you buy again.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cancellations</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>
          You can cancel from Account in the member app. Cancellation is the same number of clicks as
          signing up for a plan.
        </li>
        <li>
          Cancelling stops further use of the paid plan. It does not by itself return money already
          paid.
        </li>
        <li>Lifetime access has no renewal date. Cancelling lifetime access ends the entitlement.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Refunds</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>
          You may request a money refund to the original payment method from Account, or by emailing{' '}
          <a href="mailto:care@getbyonco.com" className="underline">care@getbyonco.com</a>.
        </li>
        <li>
          Refunds are processed through Razorpay to the original card or method, typically within
          5-10 business days after we issue them.
        </li>
        <li>
          If a payment fails, we do not grant access. Any amount captured in error is refunded to the
          original method.
        </li>
        <li>
          Second-opinion and other one-time clinical-coordination fees may be refunded if the service
          has not been delivered.
        </li>
      </ul>

      <p className="mt-6">
        For assistance:{" "}
        <a href="mailto:care@getbyonco.com" className="text-forest-ink underline">
          care@getbyonco.com
        </a>
      </p>
    </div>
  );
};

export default CancellationRefund;
